/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForServiceNowIncidentManagement extends models.GovernanceConfigurationBaseForServiceNow {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForServiceNowIncidentManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForServiceNowIncidentManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForServiceNowIncidentManagement>): GovernanceConfigurationForServiceNowIncidentManagement {
        let obj = Object.assign(new GovernanceConfigurationForServiceNowIncidentManagement(), model);
        GovernanceConfigurationForServiceNowIncidentManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForServiceNowIncidentManagement>): GovernanceConfigurationForServiceNowIncidentManagement {
        if (!model) return null;
        return GovernanceConfigurationForServiceNowIncidentManagement.newInstance(<GovernanceConfigurationForServiceNowIncidentManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForServiceNowIncidentManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForServiceNowIncidentManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForServiceNowIncidentManagement): boolean {
        if (models.GovernanceConfigurationBaseForServiceNow.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForServiceNowIncidentManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.policy_mapping) {
            models.ServiceNowPolicyMapping.fixupPrototype(this.policy_mapping);
        }
        if (this.alerts_mapping) {
            models.ServiceNowAlertMapping.fixupPrototype(this.alerts_mapping);
        }
        if (this.budget_alerts_mapping) {
            models.ServiceNowBudgetAlertMapping.fixupPrototype(this.budget_alerts_mapping);
        }
        if (this.security_alerts_mapping) {
            models.ServiceNowSecurityAlertMapping.fixupPrototype(this.security_alerts_mapping);
        }
        if (this.custom_endpoint) {
            models.ServiceNowIncidentManagementCustomEndpoint.fixupPrototype(this.custom_endpoint);
        }
        if (this.custom_fields_mapping) {
            for (let val of this.custom_fields_mapping) {
                models.ServiceNowIncidentManagementCustomFieldsMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * Attribute mapping for ServiceNow Policy
     */
    policy_mapping: models.ServiceNowPolicyMapping;

    /**
     * Attribute mapping for ServiceNow Alert
     */
    alerts_mapping: models.ServiceNowAlertMapping;

    /**
     * Attribute mapping for ServiceNow Budget Alert
     */
    budget_alerts_mapping: models.ServiceNowBudgetAlertMapping;

    /**
     * Attribute mapping for ServiceNow Security Alert
     */
    security_alerts_mapping: models.ServiceNowSecurityAlertMapping;

    /**
     * Custom Endpoint for Incident management
     */
    custom_endpoint: models.ServiceNowIncidentManagementCustomEndpoint;

    /**
     * Custom Fields Mapping of Incident Management
     */
    custom_fields_mapping: Array<models.ServiceNowIncidentManagementCustomFieldsMapping>;

}
